module.exports = __webpack_public_path__ + "static/img/2.8da9f539.png";